(function () {
  var box = document.getElementById('belnay-consent');
  if (!box) return;
  var prefs = document.querySelector('[data-consent-prefs]');
  var withApi = function (fn) {
    if (window.Shopify && window.Shopify.customerPrivacy) return fn(window.Shopify.customerPrivacy);
    if (!window.Shopify || !window.Shopify.loadFeatures) return;
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (err) {
      if (!err && window.Shopify.customerPrivacy) fn(window.Shopify.customerPrivacy);
    });
  };
  /* A choice is { analytics, marketing, preferences }; Accept and Decline are
     all three true or false, Settings lets the visitor pick per type. */
  var all = function (yes) { return { analytics: yes, marketing: yes, preferences: yes }; };
  var send = function (choice) {
    withApi(function (api) { api.setTrackingConsent(choice, function () {}); });
  };
  /* Stored as 'yes', 'no' or the JSON of a picked choice. */
  var read = function (stored) {
    if (stored === 'yes' || stored === 'no') return all(stored === 'yes');
    try { var c = JSON.parse(stored); return c && typeof c === 'object' ? c : null; } catch (e) { return null; }
  };
  var closePrefs = function () {
    if (!prefs || prefs.hidden) return;
    prefs.classList.remove('is-visible');
    prefs.hidden = true;
    document.documentElement.classList.remove('consent-prefs-open');
    var opener = box.querySelector('[data-consent-settings]');
    if (!box.hidden && opener) opener.focus();
  };
  /* Close at once and keep the answer here. Brave Shields and ad blockers stop
     Shopify's consent script, so waiting for its callback left the banner on
     screen with buttons that seemed dead (desktop, 19 Oct 2026). */
  var answer = function (choice, stored) {
    try { localStorage.setItem('belnay-consent', stored); } catch (e) {}
    box.hidden = true;
    closePrefs();
    send(choice);
  };
  /* An answer given while the script was blocked reaches Shopify once it loads. */
  try {
    var stored = read(localStorage.getItem('belnay-consent'));
    var m = document.cookie.match(/(?:^|; )_tracking_consent=([^;]*)/);
    var c = m && JSON.parse(decodeURIComponent(m[1]));
    var given = c && c.con && c.con.CMP && c.con.CMP.a;
    if (stored && given !== '1' && given !== '0') send(stored);
  } catch (e) {}
  box.querySelector('[data-consent-accept]').addEventListener('click', function () { answer(all(true), 'yes'); });
  box.querySelector('[data-consent-decline]').addEventListener('click', function () { answer(all(false), 'no'); });

  if (prefs) {
    var boxes = prefs.querySelectorAll('[data-consent-type]');
    box.querySelector('[data-consent-settings]').addEventListener('click', function () {
      var saved = null;
      try { saved = read(localStorage.getItem('belnay-consent')); } catch (e) {}
      for (var i = 0; i < boxes.length; i++) boxes[i].checked = !!(saved && saved[boxes[i].getAttribute('data-consent-type')]);
      prefs.hidden = false;
      document.documentElement.classList.add('consent-prefs-open');
      requestAnimationFrame(function () { prefs.classList.add('is-visible'); });
      prefs.querySelector('[role="dialog"]').focus();
    });
    prefs.querySelector('[data-consent-all]').addEventListener('click', function () { answer(all(true), 'yes'); });
    prefs.querySelector('[data-consent-none]').addEventListener('click', function () { answer(all(false), 'no'); });
    prefs.querySelector('[data-consent-save]').addEventListener('click', function () {
      var choice = all(false);
      for (var i = 0; i < boxes.length; i++) choice[boxes[i].getAttribute('data-consent-type')] = boxes[i].checked;
      answer(choice, JSON.stringify(choice));
    });
    var closers = prefs.querySelectorAll('[data-consent-prefs-close]');
    for (var j = 0; j < closers.length; j++) closers[j].addEventListener('click', closePrefs);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closePrefs(); });
  }
  /* Deliberately no shouldShowBanner() check: with Shopify's own banner removed
     that call can report false everywhere and would hide this one. Everyone
     without a stored answer is asked once; that is the safe reading of GDPR. */
})();
